import { CSSProperties } from "react";
import { usePalette } from "@/shared/theme";
import { twMerge } from "tailwind-merge";

type DotProps = {
  className?: string;
  color?: string;
};

export function Dot(props: DotProps) {
  const palette = usePalette();
  const { className, color = palette.primary[5] } = props;

  return (
    <div
      className={twMerge("size-2 bg-[--bg] rounded-full", className)}
      style={{ "--bg": color } as CSSProperties}
    />
  );
}

export default Dot;
